import { connect } from 'react-redux';
import PartiesList from 'components/parties/PartiesList';
import {
  fetchPartiesData,
  enableDisableParty,
  setGridFilter,
  clearGridFilter,
} from 'data/parties/Parties.actions';

import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      filters: state.parties.filters || [],
      fetchingParties: state.parties.fetchingParties,
      partiesData: state.parties.partiesData,
      submitting: state.parties.changingStatusParty,
      user: state.app.user,
    },
    state,
    'partyTypes',
    'regions'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFilter: (name, value) => dispatch(setGridFilter(name, value)),
    clearFilters: () => dispatch(clearGridFilter()),
    fetchParties: () => dispatch(fetchPartiesData()),
    enableDisableParty: partyId => dispatch(enableDisableParty(partyId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartiesList);
